import React, { useState } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { CopyToClipboardIcon, CheckmarkBackgroundIcon } from '@paypalcorp/pp-react';
import styles from '../../Page/IntegrationPageSection/PreviewWrapper/TestCards.module.less';
import { trackButtonClick, trackCopyCodeTab } from '../../lib/fpti';

const CopyToClipboard = ({ contentToCopy, tabName }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = (content, tab) => {
    copy(content);
    setIsCopied(true);
    if (tab) trackCopyCodeTab('Copy Clipboard', tabName);
    else trackButtonClick('Copy Clipboard', content);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div className={styles.copy_icon}>
      {isCopied ? (
        <CheckmarkBackgroundIcon />
      ) : (
        <CopyToClipboardIcon onClick={() => handleCopy(contentToCopy, tabName)} />
      )}
    </div>
  );
};

CopyToClipboard.propTypes = {
  contentToCopy: PropTypes.string.isRequired
};

export default CopyToClipboard;
